import { FC, ReactNode, useEffect, useState } from 'react';
import { Box, alpha, lighten, useTheme } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import Sidebar from './Sidebar';
import Header from './Header';
import { useAppSelector } from 'src/store/hook';
import AutoBreadcrumb from 'src/components/Breadcrumbs/AutoBreadcrumbs';

interface SidebarLayoutProps {
  children?: ReactNode;
}

const SidebarLayout: FC<SidebarLayoutProps> = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const [isShowed, setIsShowed] = useState(true);
  const token = useAppSelector((state: any) => state.token.token);

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  const appLabels = {
    add: 'Tambah Baru',
    new: 'Tambah Baru',
    edit: 'Ubah',
    profile: 'Profil',
    'member-list': 'Daftar Member',
    point: 'Poin Member',
    'member-vouchers': 'Voucher Member',
    'complaint-center': 'Pusat Keluhan',
    region: 'Master Region',
    'area-list': 'Daftar Area',
    'outlet-list': 'Daftar Outlet',
    'category-master': 'Master Kategori',
    'product-list': 'Master Produk',
    'storefront-product-list': 'Daftar Produk Etalase',
    'payment-history': 'Riwayat Pembayaran',
    'order-list': 'Daftar Pesanan',
    'voucher-exchange-history': 'Riwayat Penukaran Voucher',
    'news-promotion': 'Berita & Promo',
    'badge-level-rule-configuration': 'Aturan Level Badge',
    'voucher-management-configuration': 'Manajemen Voucher',
    'payment-point-configuration': 'Poin Payment',
    delivery: 'Pengiriman',
    'complaint-category-configuration': 'Kategori Keluhan',
    'admin-management-configuration': 'Manajemen Admin',
    'product-setting': 'Pengaturan Produk',
    'packaging-master': 'Master Kemasan',
    'packaging-catalog-list': 'Daftar Katalog Kemasan',
    'packaging-setting': 'Pengaturan Kemasan'
  };

  useEffect(() => {
    if (!token) navigate('/auth/login');
  }, [token, navigate]);

  return (
    <>
      <Box
        sx={{
          flex: 1,
          height: '100%',

          '.MuiPageTitle-wrapper': {
            background:
              theme.palette.mode === 'dark'
                ? theme.colors.alpha.trueWhite[5]
                : theme.colors.alpha.white[50],
            marginBottom: `${theme.spacing(4)}`,
            boxShadow:
              theme.palette.mode === 'dark'
                ? `0 1px 0 ${alpha(
                    lighten(theme.colors.primary.main, 0.7),
                    0.15
                  )}, 0px 2px 4px -3px rgba(0, 0, 0, 0.2), 0px 5px 12px -4px rgba(0, 0, 0, .1)`
                : `0px 2px 4px -3px ${alpha(
                    theme.colors.alpha.black[100],
                    0.1
                  )}, 0px 5px 12px -4px ${alpha(
                    theme.colors.alpha.black[100],
                    0.05
                  )}`
          }
        }}
      >
        <Header
          callback={(isShowed) => setIsShowed(isShowed)}
          isShowed={isShowed}
        />
        <Sidebar isShowed={isShowed} />
        <Box
          sx={{
            position: 'relative',
            zIndex: 5,
            display: 'block',
            flex: 1,
            pt: `${theme.header.height}`,
            [theme.breakpoints.up('lg')]: {
              ml: isShowed ? `${theme.sidebar.width}` : '0'
            },
            '.MuiContainer-root': {
              width: '100%'
            }
          }}
        >
          <Box display="block" sx={{ margin: '12px' }}>
            <Box sx={{ m: 3, marginBottom: -2, marginTop: 4 }}>
              <AutoBreadcrumb
                pathname={location.pathname}
                onNavigate={handleNavigate}
                customLabels={appLabels}
              />
            </Box>
            <Outlet />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default SidebarLayout;
